import { B2bColorScheme } from 'shared-types/colorScheme';
import { B2bUserType } from 'shared-types/user';

export const bamColorPalette = {
  black: '#000000',
  dark: '#262626',
  white: '#FFFFFF',
  darkGray: '#2E2E2E',
  regularGray: '#A3A3A3',
  lightGray: '#B5B5B5',
  red: '#FF0000',
  mediumRed: '#d90036',
  green: '#29B740',
  pink: '#E72E5C',
  goldTips: '#FCF8AC',
  vGrayWhiteGradient:
    'linear-gradient(180deg, rgba(172, 172, 172, 0.1) 0%, rgba(254, 247, 244, 0) 100%)',
};

export const bamColors: B2bColorScheme = {
  userType: B2bUserType.BAM,
  primaryColor: bamColorPalette.black,
  tertiaryColorLight: bamColorPalette.dark,

  primaryHighlightColor: bamColorPalette.pink,

  backgroundColor: bamColorPalette.black,
  backgroundColorDark: bamColorPalette.black,
  backgroundColorLight: bamColorPalette.lightGray,
  secondaryBackgroundColor: bamColorPalette.darkGray,
  tertiaryBackgroundColor: bamColorPalette.black,

  primaryGradient: bamColorPalette.lightGray,
  secondaryGradient: bamColorPalette.lightGray,

  primaryTextColor: bamColorPalette.white,
  secondaryTextColor: bamColorPalette.darkGray,
  tertiaryTextColor: bamColorPalette.regularGray,

  secondaryHighlightColor: bamColorPalette.red,
  tertiaryHighlightColor: bamColorPalette.green,
  otherHighLightColor: bamColorPalette.pink,

  primaryInactiveColor: bamColorPalette.regularGray,
  secondaryInactiveColor: bamColorPalette.darkGray,

  playerAccentColor1: bamColorPalette.goldTips,
  playerAccentColor2: 'transparent',
  playerAccentColor3: bamColorPalette.mediumRed,

  white: '#FFFFFF',
  black: '#000000',
  transparent: '#00000000',
};
